import { Search } from "lucide-react";

// Text search + category + brand filters for the 214-model catalog.
export default function CatalogToolbar({ t, search, setSearch, category, setCategory, categoryOptions, brand, setBrand, brandOptions, count, total }) {
  return (
    <div className="mb-4 flex items-center gap-3 flex-wrap" data-testid="catalog-toolbar">
      <div className="relative flex-1 min-w-[220px] max-w-md">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500"/>
        <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder={t("machines.catalogSearchPh")}
          className="w-full pl-9 pr-3 py-2 rounded-md text-sm" data-testid="catalog-search"/>
      </div>
      <select value={category} onChange={(e) => setCategory(e.target.value)} className="px-3 py-2 rounded-md text-sm" data-testid="catalog-category-filter">
        <option value="">{t("machines.allCategories")}</option>
        {categoryOptions.map((c) => <option key={c.id} value={c.id}>{c.name} ({c.n})</option>)}
      </select>
      <select value={brand} onChange={(e) => setBrand(e.target.value)} className="px-3 py-2 rounded-md text-sm" data-testid="brand-filter" aria-label={t("machines.filterByBrand")}>
        <option value="">{t("machines.filterAll", { n: total })}</option>
        {brandOptions.map((b) => <option key={b} value={b}>{b}</option>)}
      </select>
      <span className="text-xs text-slate-500 font-mono-data" data-testid="catalog-results-count">{t("machines.catalogResults", { n: count, total })}</span>
    </div>
  );
}
